/* eslint-disable no-extend-native */

String.prototype.thousandSeparator = function () {
  try {
    const str = this
    const newStr = str.toLowerCase().replace(/[^0-9]+/g, '')
    return newStr.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ')
  } catch (e) {
    console.error(e)
    return ''
  }
}

String.prototype.toNum = function () {
  try {
    const str = this
    const newStr = str.toLowerCase().replace(/[^0-9]+/g, '')
    return Number(newStr)
  } catch (e) {
    console.error(e)
    return 0
  }
}

String.prototype.toPhone = function () {
  try {
    const str = this
    const newStr = str.toLowerCase().replace(/[^0-9]+/g, '')
    let match = newStr.match(/^(7|8|)?(\d{3})(\d{3})(\d{2})(\d{2})$/)

    if (match) {
      let intlCode = match[1] ? '+' + match[1] : ''
      return [
        intlCode,
        ' (',
        match[2],
        ') ',
        match[3],
        '-',
        match[4],
        '-',
        match[5]
      ].join('')
    }

    return ''
  } catch (e) {
    console.error(e)
    return ''
  }
}

String.prototype.toStandardPhone = function () {
  try {
    const str = this
    const newStr = str.toLowerCase().replace(/[^0-9]+/g, '')
    let match = newStr.match(/^(7|8|)?(\d{3})(\d{3})(\d{2})(\d{2})$/)

    if (match) {
      let intlCode = match[1] ? match[1] : 7
      return [intlCode, match[2], match[3], match[4], match[5]].join('')
    }

    return ''
  } catch (e) {
    console.error(e)
    return ''
  }
}

String.prototype.forMaskPhone = function () {
  try {
    const str = this
    const newStr = str.toLowerCase().replace(/[^0-9]+/g, '')
    let match = newStr.match(/^(\d)(\d{3})(\d{3})(\d{2})(\d{2})$/)

    if (match) {
      return [7, match[2], match[3], match[4], match[5]].join('')
    }

    return ''
  } catch (e) {
    console.error(e)
    return ''
  }
}
String.prototype.toLowerFirstLatter = function () {
  try {
    const str = this
    const newStr = str?.length > 0 ? str[0].toLowerCase() + str.slice(1) : ''

    return newStr
  } catch (e) {
    console.error(e)
    return ''
  }
}
